import * as Yup from "yup";
import { IUseBoolean, useBoolean } from "../../../hooks/use-boolean";
import { IDepartment, IDepartmentUpdate } from "../../../types/department";
import { enqueueSnackbar } from "notistack";
import { UpdateDepartmentService } from "../../../services/departments";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

const useDepartmentUpdate = (getDepartments: VoidFunction, loadingTable: IUseBoolean) => {

    // hooks    
    const loadingUpdate = useBoolean(false);
    const openUpdateDialog = useBoolean();

    // rhf
    const NewDepartmentSchema = Yup.object().shape({
        id: Yup.number().required('Informe o departamento'),
        name: Yup.string().required('Informe o nome do departamento').max(255, 'O nome deve conter no máximo 255 caracteres'),
        branch: Yup.object().shape({
            id: Yup.number().required(),
            name: Yup.string().required(),
            code: Yup.string().required(),
        }).required("Selecione uma filial"),
        manager: Yup.object().shape({
            id: Yup.number().required(),
            name: Yup.string().required(),
            email: Yup.string().required(),
        }).required("Selecione o gestor(a)")
    });

    const methodsUpdate = useForm({
        resolver: yupResolver<IDepartmentUpdate>(NewDepartmentSchema),
        defaultValues: {
            id: null!,
            name: '',
            branch: null!,
            manager: null!
        }
    });

    const {
        handleSubmit,
        reset,
        setValue
    } = methodsUpdate;

    // functions    
    const setValuesUpdate = (department: IDepartment) => {
        setValue("id", department.id, { shouldValidate: true });
        setValue("name", department.name, { shouldValidate: true });
        setValue("branch", department.branch, { shouldValidate: true });
        setValue("manager", department.manager, { shouldValidate: true })

        openUpdateDialog.onTrue();
    }

    const resetValuesUpdate = () => {
        reset({
            id: null!,
            name: '',
            branch: null!
        });
        openUpdateDialog.onFalse();
    }

    const onSubmitUpdate = handleSubmit(async (data: IDepartmentUpdate) => {

        loadingUpdate.onTrue();
        loadingTable.onTrue();

        await UpdateDepartmentService(data).then(resp => {
            loadingUpdate.onFalse();
            enqueueSnackbar(resp.data.message);
            resetValuesUpdate();
            getDepartments();
        }).catch(error => {
            loadingUpdate.onFalse();
            loadingTable.onFalse();
            enqueueSnackbar(error?.response?.data?.message ?? 'Ocorreu um erro', {
                variant: 'error'
            });
        });

    });

    return {
        loadingUpdate,
        openUpdateDialog,
        onSubmitUpdate,
        methodsUpdate,
        setValuesUpdate
    }
}

export default useDepartmentUpdate;